import {createAction, props} from '@ngrx/store';

import {AppSettings, Language} from '@appModels/store/settings/settings.model';
import {buildingStringActionType} from '@appUtil/strings';

const typeReducer = 'Settings';

export const CHANGE_LANGUAGE = createAction(
  '[Settings] Change Language',
  props<{language: Language}>(),
);
export const SET_APPLICATION_CONFIGURATION = createAction(
  '[Settings] Set application configuration',
  props<{appSettings: AppSettings}>(),
);
export const SET_INITIALIZATION_COMPLETE = createAction(
  '[Settings] Set application initialization complete',
);
export const SET_BROWSER = createAction(
  '[Settings] Set browser',
  props<{currentBrowser: string}>(),
);
export const SET_LOAD_CONFIGURATION_PRORATED_ACTIVE = createAction(
  buildingStringActionType(typeReducer, 'Set load configuration prorated active'),
);
export const SET_SUCCESS_CONFIGURATION_PRORATED_ACTIVE = createAction(
  buildingStringActionType(typeReducer, 'Set success configuration prorated active'),
  props<{value: boolean}>(),
);
/**
 * @description Set iso code of the region of whoAmI response to get a new client string.
 * @param ClaveIsoRegion iso code of the region
 * **/
export const SET_INFO_USER_REGION = createAction(
  buildingStringActionType(typeReducer, 'Set info user region'),
  props<{ClaveIsoRegion: string}>(),
);
